export default __webpack_public_path__ + "static/media/over-axle-size-weight.e1a514f9.svg";